module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "service.4249c3ba.svg";